'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["dropdownClassName", "error", "fontOptions", "onChange", "StyledUITextToolbarSelectComponent", "value", "VariantButtonComponent", "VariantOptionComponent", "VariantSelectComponent"];
import PropTypes from 'prop-types';
import { useState } from 'react';
import I18n from 'I18n';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import TextToolbarSelectOption from '../TextToolbarSelectOption';
import VariantSelectOption from './VariantSelectOption';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.formatting.FontSelect.${suffix}`;
const Option = ({
  value,
  help,
  text
}) => {
  if (help) {
    return /*#__PURE__*/_jsx(UIHelpIcon, {
      title: help,
      tooltipProps: {
        placement: 'bottom'
      },
      children: text
    });
  } else {
    return /*#__PURE__*/_jsx("span", {
      style: {
        fontFamily: value
      },
      children: text
    });
  }
};
const customFontsValue = fontOptions => {
  const customFonts = fontOptions.find(option => option.text === I18n.text(i18nKey('customFontsTitle')));
  if (!customFonts || !customFonts.options) {
    return [];
  }
  return customFonts.options.map(option => option.value);
};
const renderFontOption = (option, dropdownClassName, setOpen, onChange, VariantOptionComponent, VariantButtonComponent, VariantSelectComponent) => {
  if (!option.text) {
    return null;
  } else if (option.variants) {
    return /*#__PURE__*/_jsx(VariantSelectOption, {
      dropdownClassName: dropdownClassName,
      option: option,
      setOpen: setOpen,
      onChange: onChange,
      OptionComponent: TextToolbarSelectOption,
      VariantButtonComponent: VariantButtonComponent
      // this is for the fallback that will be styled...waiting for
      // BE (https://git.hubteam.com/HubSpot/ContentFonts/issues/43)
      ,
      VariantOptionComponent: VariantOptionComponent,
      VariantSelectComponent: VariantSelectComponent
    });
  }
  return /*#__PURE__*/_jsx(TextToolbarSelectOption, {
    title: option.text,
    children: /*#__PURE__*/_jsx(Option, {
      value: option.value,
      text: option.text,
      help: option.help
    })
  });
};
function GroupedFontSelectBody(props) {
  const {
      dropdownClassName,
      error,
      fontOptions,
      onChange,
      StyledUITextToolbarSelectComponent,
      value,
      VariantButtonComponent,
      VariantOptionComponent,
      VariantSelectComponent
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [open, setOpen] = useState(false);
  const customFontsValues = customFontsValue(fontOptions);
  return /*#__PURE__*/_jsx(StyledUITextToolbarSelectComponent, Object.assign({}, rest, {
    value: value,
    searchable: false,
    closeOnTargetLeave: true,
    options: fontOptions,
    open: open,
    error: error,
    placeholder: I18n.text(i18nKey('placeholder')),
    dropdownClassName: `${dropdownClassName} font-select-dropdown`,
    resultsClassName: "font-select-results",
    onChange: evt => {
      const targetValue = evt.target.value;
      if (customFontsValues.includes(targetValue)) {
        console.log('Selecting custom font option', targetValue);
      } else {
        onChange(evt);
        setOpen(false);
      }
    },
    onOpenChange: () => {
      setOpen(!open);
    },
    onSelectedOptionChange: evt => {
      if (evt.target.value && evt.target.value.variants) {
        setOpen(true);
      }
    },
    optionRenderer: option => renderFontOption(option, dropdownClassName, setOpen, onChange, VariantOptionComponent, VariantButtonComponent, VariantSelectComponent)
  }));
}
GroupedFontSelectBody.propTypes = {
  dropdownClassName: PropTypes.string,
  error: PropTypes.bool,
  fontOptions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  StyledUITextToolbarSelectComponent: PropTypes.elementType,
  value: PropTypes.string,
  VariantButtonComponent: PropTypes.elementType,
  VariantOptionComponent: PropTypes.elementType,
  VariantSelectComponent: PropTypes.elementType
};
GroupedFontSelectBody.defaultProps = {
  fontOptions: []
};
export default GroupedFontSelectBody;